var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-between" }, [
    _c(
      "div",
      {
        staticClass: "charts-box",
        on: {
          click: function ($event) {
            return _vm.goGraph("/zxk/search/enterpriseGraph")
          },
        },
      },
      [
        _c("img", {
          staticClass: "charts-img",
          attrs: {
            src: "https://public-oss.qizhidao.com/APP/202309/c7aa154aa91f4be7a14b7698e2249847.png",
            alt: "企业图谱",
          },
        }),
        _c("p", { staticClass: "title" }, [_vm._v("企业架构图")]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "charts-box",
        on: {
          click: function ($event) {
            return _vm.goGraph("/zxk/search/equityPenetration")
          },
        },
      },
      [
        _c("img", {
          staticClass: "charts-img",
          attrs: {
            src: "https://public-oss.qizhidao.com/APP/202309/7ccd035833144a40af601448796ebec3.png",
            alt: "股权穿透图",
          },
        }),
        _c("p", { staticClass: "title" }, [_vm._v("股权全景穿透")]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "charts-box",
        on: {
          click: function ($event) {
            return _vm.goGraph("/zxk/search/shareholderStructure")
          },
        },
      },
      [
        _c("img", {
          staticClass: "charts-img",
          attrs: {
            src: "https://public-oss.qizhidao.com/APP/202309/8cd3669ef9be4c9996e9ad4c341e4011.png",
            alt: "股权结构图",
          },
        }),
        _c("p", { staticClass: "title" }, [_vm._v("股东持股穿透")]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "charts-box",
        on: {
          click: function ($event) {
            return _vm.goGraph("/zxk/search/investmentPenetration")
          },
        },
      },
      [
        _c("img", {
          staticClass: "charts-img",
          attrs: {
            src: "https://public-oss.qizhidao.com/APP/202309/8cd3669ef9be4c9996e9ad4c341e4011.png",
            alt: "股权结构图",
          },
        }),
        _c("p", { staticClass: "title" }, [_vm._v("对外投资穿透")]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }